import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

function WinPercentageWidget({ data }) {
  const teamAPercentage = data?.[0]?.sWinPercentage
  const teamBPercentage = data?.[1]?.sWinPercentage
  const tiePercentage = data?.[2]?.sWinPercentage
  if (teamAPercentage && teamBPercentage && teamAPercentage > 0 && teamBPercentage > 0) {
    return (
      <div className='common-box '>
        <div className={styles.title}>#WinPercentage</div>
        <div className='d-flex justify-content-between'>

          <div className={`${styles.teamName} text-start`} style={{ width: `${teamAPercentage}%` }}>
            <div>{data[0]?.sTitle}</div>
            <div className={styles.percentage} style={{ color: '#F25724' }}>{`${teamAPercentage}%`}</div>
          </div>
          {tiePercentage > 0 &&
            <div className={`${styles.teamName} text-center`} style={{ width: `${tiePercentage}%` }}>
              <div>Draw</div>
              <div className={styles.percentage} style={{ color: '#B5BAC2' }}>{`${tiePercentage}%`}</div>
            </div>
          }
          <div className={`${styles.teamName} text-end`} style={{ width: `${teamBPercentage}%` }}>
            <div>{data[1]?.sTitle}</div>
            <div className={`${styles.percentage} ${styles.colorBlue}`}>{`${teamBPercentage}%`}</div>
          </div>
        </div>
        <div className='d-flex'>
          <div className={styles.bar} style={{ width: `${teamAPercentage}%`, background: '#F25724' }}> </div>
          <div className={styles.bar} style={{ width: `${tiePercentage}%`, background: '#B5BAC2' }}> </div>
          <div className={`${styles.bar} ${styles.brBlue}`} style={{ width: `${teamBPercentage}%` }}> </div>
        </div>
      </div>
    )
  } else {
    return ''
  }
}
WinPercentageWidget.propTypes = {
  data: PropTypes.any
}
export default WinPercentageWidget
